<script>
import Layout from '@layouts/main.vue'
import {
  shiftMethods,
  dutyMethods,
  replacementMethods,
  shiftComputed,
  oncallDutyComputed,
  oncallDutyMethods,
  authComputed,
  notificationComputed,
  notificationMethods,
  cityMethods,
  cityComputed,
} from '@state/helpers'
import dayjs from 'dayjs'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/lt'

export default {
  page: {
    title: 'Galimybės',
  },

  components: { Layout, DatePicker },

  data() {
    return {
      city: null,
      programs: null,
      date: null,
      datePickerDate: null,
      dutyId: null,
      reason: '',
      nv_program: false,
      kc_program: false,
      grupese_program: false,
      dayChange: 1,
      dayOptions: [
        {
          id: 1,
          label: '1d',
        },
        {
          id: 7,
          label: '7d',
        },
      ],
      programsOptions: [
        { id: '', label: 'Visos programos' },
        { id: 'nv', label: 'NV galimybės' },
        { id: 'kc', label: 'KC galimybės' },
        { id: 'grupese', label: 'Grupių galimybės' },
      ],
      dialogs: {
        dutyTake: {
          visible: false,
          dutyCell: null,
          dateTime: '',
        },
        dutyCancel: {
          visible: false,
        },
        dutyDelete: {
          visible: false,
          dutyCell: null,
        },
        dutyReplace: {
          visible: false,
          replacement: null,
        },
        dutyInfo: {
          visible: false,
          dutyCell: null,
          isExplanationRequired: null,
        },
      },
    }
  },

  computed: {
    ...authComputed,

    ...shiftComputed,

    ...oncallDutyComputed,

    ...notificationComputed,

    ...cityComputed,

    dayNames() {
      if (!this.shifts) return []

      const dayNames = ['S', 'P', 'A', 'T', 'K', 'P', 'Š']
      const result = []
      for (let i = 0; i < 10; i += 1) {
        result.push(dayNames[this.shifts[0].duties[i].week_day % 7])
      }
      return result
    },

    dateTitle() {
      const months = [
        '',
        'Sausis',
        'Vasaris',
        'Kovas',
        'Balandis',
        'Gegužė',
        'Birželis',
        'Liepa',
        'Rugpjūtis',
        'Rugsėjis',
        'Spalis',
        'Lapkritis',
        'Gruodis',
      ]

      const year = dayjs(this.date).format('YYYY')
      const month = months[dayjs(this.date).format('M')]
      return `${year} ${month}`
    },

    rowsCount() {
      const biggerCities = ['Vilnius', 'Kaunas']
      return biggerCities.includes(this.city) ? 6 : 4
    },

    canSeePrograms() {
      const dutyPrograms = ['nv', 'kc', 'grupese']
      const userDutyPrograms = this.currentUser.programs.filter((p) =>
        dutyPrograms.includes(p),
      )
      return (
        this.currentUser.role === 'admin' ||
        this.currentUser.role === 'coordinator' ||
        userDutyPrograms.length > 1
      )
    },
  },

  created() {
    if (this.currentUser.programs.toString() == 'drauge') {
      this.$router.push('/savanoriai')
      return
    }

    this.datePickerDate = dayjs().format('YYYY-MM-DD')
    this.date = dayjs()
    this.loadCity()
    this.loadShiftsList()
    this.fetchAllCities()
  },

  methods: {
    ...shiftMethods,

    ...dutyMethods,

    ...replacementMethods,

    ...oncallDutyMethods,

    ...notificationMethods,

    ...cityMethods,

    loadCity() {
      this.city = this.currentUser.city
    },

    loadShiftsList() {
      this.datePickerDate = this.date.format('YYYY-MM-DD')
      this.fetchAllShifts({
        start_date: this.date.format('YYYY-MM-DD'),
        city: this.city,
        programs: this.programs,
      })
      this.fetchAllOncallDuties({
        start_date: this.date.format('YYYY-MM-DD'),
        city: this.city,
      })
      this.fetchAllNotifications()
    },

    onClickDutyCell(dutyCell) {
      // Users with status "suspended" can't participate on their own
      if (this.currentUser.status === 3) {
        return
      }

      const { shiftIndex, dayIndex } = dutyCell

      if (dutyCell.state === 'free') {
        const takenCells = this.dutyCells(shiftIndex, dayIndex).filter(
          (x) => x.user_id === this.currentUser.id,
        )
        if (!takenCells.length) {
          this.onClickDutyAdd(dutyCell)
        }
      } else {
        const busyCells = this.dutyCells(shiftIndex, dayIndex).filter(
          ({ state }) => state === 'busy',
        )
        const daysDiff = dayjs(
          this.shifts[shiftIndex].duties[dayIndex].date,
        ).diff(dayjs(), 'days')
        this.dialogs.dutyInfo.visible = true
        this.dialogs.dutyInfo.dutyCell = dutyCell
        this.dialogs.dutyInfo.isExplanationRequired =
          daysDiff < 2 && busyCells.length < 2
      }
    },

    onClickCancelOrDelete() {
      this.dialogs.dutyInfo.visible = false
      this.reason = ''
      this.nv_program = false
      this.kc_program = false
      this.grupese_program = false

      if (this.dialogs.dutyInfo.isExplanationRequired) {
        this.dutyId = this.dialogs.dutyInfo.dutyCell.id
        this.dialogs.dutyCancel.visible = true
      } else {
        this.onClickDutyDelete(this.dialogs.dutyInfo.dutyCell)
      }
    },

    onClickDutyAdd(dutyCell) {
      if (this.currentUser.role !== 'volunteer') return

      this.dialogs.dutyTake.dutyCell = dutyCell
      this.dialogs.dutyTake.visible = true
      const date =
        this.shifts[dutyCell.shiftIndex].duties[dutyCell.dayIndex].date
      const time = this.shifts[dutyCell.shiftIndex].title + ' val.'
      this.dialogs.dutyTake.dateTime = `${date} ${time}`
    },

    onClickReplacement(replacement) {
      this.dialogs.dutyReplace.visible = true
      this.dialogs.dutyReplace.replacement = replacement
    },

    onClickDutyDelete(dutyCell) {
      if (
        dutyCell.user_id !== this.currentUser.id &&
        this.currentUser.role === 'volunteer'
      )
        return

      this.dialogs.dutyDelete.visible = true
      this.dialogs.dutyDelete.dutyCell = dutyCell
    },

    dutyCells(shiftIndex, dayIndex) {
      const result = []
      const volunteers = this.shifts[shiftIndex].duties[dayIndex].volunteers
      for (
        let i = 0;
        i < Math.max(volunteers.length + 1, this.rowsCount);
        i += 1
      ) {
        if (volunteers[i]) {
          result.push({
            ...volunteers[i],
            state: volunteers[i].kid ? 'taken' : 'busy',
            programs: volunteers[i].programs,
            shiftIndex,
            dayIndex,
          })
        } else {
          result.push({ state: 'free', shiftIndex, dayIndex })
        }
      }
      return result
    },

    onClickPrevWeek() {
      this.date = dayjs(this.date).subtract(this.dayChange, 'days')
      this.loadShiftsList()
    },

    onClickNextWeek() {
      this.date = dayjs(this.date).add(this.dayChange, 'days')
      this.loadShiftsList()
    },

    onSubmitReason() {
      if (!this.reason) return

      this.deleteDuty({ id: this.dutyId, reason: this.reason }).then(() => {
        this.dialogs.dutyCancel.visible = false
        this.reason = ''
        this.nv_program = false
        this.kc_program = false
        this.grupese_program = false
        this.loadShiftsList()
      })
    },

    onSubmitTake() {
      if (
        this.currentUser.programs.length > 1 &&
        !this.nv_program &&
        !this.kc_program &&
        !this.grupese_program
      ) {
        alert('Pasirinkite programą')
        return
      }

      const { shiftIndex, dayIndex } = this.dialogs.dutyTake.dutyCell
      this.createDuty({
        shift_id: this.shifts[shiftIndex].id,
        date: this.shifts[shiftIndex].duties[dayIndex].date,
        notes: this.reason,
        nv_program:
          this.nv_program || this.currentUser.programs.toString() == 'nv',
        kc_program:
          this.kc_program || this.currentUser.programs.toString() == 'kc',
        grupese_program:
          this.grupese_program ||
          this.currentUser.programs.toString() == 'grupese',
      }).then(() => {
        this.dialogs.dutyTake.visible = false
        this.reason = ''
        this.loadShiftsList()
      })
    },

    onSubmitDelete() {
      this.deleteDuty({
        id: this.dialogs.dutyDelete.dutyCell.id,
        reason: this.reason,
      }).then(() => {
        this.dialogs.dutyDelete.visible = false
        this.loadShiftsList()
      })
    },

    onSubmitReplace() {
      this.createReplacement({
        id: this.dialogs.dutyReplace.replacement.id,
      }).then(() => {
        this.dialogs.dutyReplace.visible = false
        this.loadShiftsList()
      })
    },

    replacementDate(replacement) {
      return dayjs(replacement.date).format('MM.DD')
    },

    onClickOncallDutyCell(user_id, { id, date, is_oncall }) {
      if (!is_oncall) {
        this.createOncallDuty({
          user_id,
          date,
        }).then(this.loadShiftsList)
      } else {
        this.deleteOncallDuty({
          id,
        }).then(this.loadShiftsList)
      }
    },

    onClickDeleteNotification(notificationId) {
      this.deleteNotification(notificationId).then(this.loadShiftsList)
    },

    onChangeCityOrPrograms() {
      this.loadShiftsList()
    },

    onDateChange(date) {
      this.date = dayjs(date)
      this.loadShiftsList()
    },
  },
}
</script>

<template>
  <Layout>
    <base-page-title>
      <template v-slot:title>
        <div class="text-2xl font-bold"> Galimybės </div>
      </template>
      <template v-slot:actions>
        <div class="flex flex-col lg:flex-row">
          <div class="mb-2">
            <div class="text-xl mr-2 inline-block pt-2">{{ dateTitle }}</div>
            <div class="w-12 inline-block">
              <base-btn @click="onClickPrevWeek">
                <font-awesome-icon :icon="['fas', 'chevron-left']" />
              </base-btn>
            </div>
            <div class="w-12 inline-block ml-2">
              <base-btn @click="onClickNextWeek">
                <font-awesome-icon :icon="['fas', 'chevron-right']" />
              </base-btn>
            </div>
          </div>
          <div
            v-if="
              currentUser.role === 'admin' || currentUser.role === 'coordinator'
            "
            class="lg:ml-2 mb-4 w-full lg:w-16"
          >
            <base-select v-model="dayChange" :options="dayOptions || []" />
          </div>
          <div
            v-if="
              currentUser.role === 'admin' || currentUser.role === 'coordinator'
            "
            class="lg:ml-2 mb-4 w-full lg:w-40 datepicker"
          >
            <DatePicker
              v-model="datePickerDate"
              value-type="format"
              format="YYYY-MM-DD"
              @change="onDateChange"
            />
          </div>
          <div
            v-if="currentUser.role === 'admin'"
            class="lg:ml-2 w-full lg:w-40"
          >
            <base-select
              v-model="city"
              :options="cityOptions || []"
              type="text"
              @change="onChangeCityOrPrograms"
            />
          </div>
          <div v-if="canSeePrograms" class="lg:ml-2 w-full lg:w-40">
            <base-select
              v-model="programs"
              :options="programsOptions || []"
              type="text"
              @change="onChangeCityOrPrograms"
            />
          </div>
        </div>
      </template>
    </base-page-title>

    <base-notification
      v-if="shiftsAlert && shiftsAlert.show"
      class="mb-8"
      color="yellow"
    >
      Šiuo metu turite surinkę {{ shiftsAlert.total_hours }} budėjimo val.
    </base-notification>

    <template v-if="notifications && notifications.length">
      <base-notification
        v-for="notification in notifications"
        :key="notification.id"
        class="mb-8"
        color="green"
      >
        <div class="flex flex-column">
          <div class="flex-1">
            {{ notification.text }}
          </div>
          <base-btn-text
            class="text-xs px-2 py-1 opacity-75"
            @click="onClickDeleteNotification(notification.id)"
            >X</base-btn-text
          >
        </div>
      </base-notification>
    </template>

    <div v-for="replacement in replacements" :key="replacement.id" class="mb-8">
      <base-notification
        v-if="replacement.user_id === currentUser.id"
        color="red"
      >
        Jūs atšaukėte budėjimą {{ replacementDate(replacement) }} d. Šiuo laiku
        nėra pakankamai pasižymėjusių savanorių, todėl reikia rasti pamainą.
      </base-notification>
      <base-notification v-else class="cursor-pointer" color="yellow">
        <div @click="onClickReplacement(replacement)">
          {{ replacement.first_name }} {{ replacement.last_name }} atšaukė
          galimybę {{ replacementDate(replacement) }} d.
          {{ replacement.shift_title }} val. Paspauskite čia jeigu norite paimti
          pamainą.
        </div>
      </base-notification>
    </div>

    <div class="-mx-4 lg:-mx-8">
      <div class="overflow-x-auto">
        <table class="table-auto w-full">
          <thead>
            <tr>
              <th class="text-left w-40">Pamainos</th>
              <th
                v-for="(day, dayIndex) in dayNames"
                :key="dayIndex"
                class="text-center"
              >
                {{ day }}
                <br />
                {{ shifts[0].duties[dayIndex].date.split('-')[2] }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(shift, shiftIndex) in shifts" :key="shift.id">
              <td class="text-lg">
                {{ shift.title }}
              </td>
              <td
                v-for="(day, dayIndex) in dayNames"
                :key="dayIndex"
                class="align-top"
              >
                <div
                  v-for="(dutyCell, cellIndex) in dutyCells(
                    shiftIndex,
                    dayIndex, // eslint-disable-line
                  )"
                  :key="cellIndex"
                  class="mb-1 px-3 py-1 rounded text-xs text-center relative"
                  :class="{
                    'bg-green-400':
                      dutyCell.state === 'free' && currentUser.status === 3,
                    'bg-green-400 cursor-pointer':
                      dutyCell.state === 'free' && currentUser.status !== 3,
                    'bg-purple-300 cursor-pointer': dutyCell.state === 'taken',
                    'bg-yellow-400 cursor-pointer':
                      dutyCell.state === 'busy' &&
                      dutyCell.programs.toString() === 'nv',
                    'bg-pink-400 cursor-pointer':
                      dutyCell.state === 'busy' &&
                      dutyCell.programs.toString() === 'kc',
                    'bg-pink-600 cursor-pointer':
                      dutyCell.state === 'busy' &&
                      dutyCell.programs.toString() === 'nv,kc',
                    'bg-indigo-400 cursor-pointer':
                      dutyCell.state === 'busy' &&
                      dutyCell.programs.toString() === 'grupese',
                    'bg-indigo-600 cursor-pointer':
                      dutyCell.state === 'busy' &&
                      dutyCell.programs.toString().includes('grupese') &&
                      dutyCell.programs.length > 1,
                  }"
                  @click="onClickDutyCell(dutyCell)"
                >
                  <template v-if="dutyCell.first_name">
                    {{ dutyCell.first_name }}
                    {{ dutyCell.last_name.slice(0, 3) }}.
                    <font-awesome-icon
                      v-if="dutyCell.notes"
                      :icon="['fas', 'comment']"
                      class="opacity-75"
                    />
                  </template>
                  <span v-else class="text-green-400">-</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="oncallDuties && oncallDuties.length"
        class="mt-8 overflow-x-auto"
      >
        <table class="table-auto w-full">
          <thead>
            <tr>
              <th class="text-left w-40">Koordinavimas</th>
              <th
                v-for="(day, dayIndex) in dayNames"
                :key="dayIndex"
                class="text-center"
              >
                {{ day }}
                <br />
                {{ shifts[0].duties[dayIndex].date.split('-')[2] }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="oncallDuty in oncallDuties" :key="oncallDuty.user_id">
              <td>{{ oncallDuty.first_name }} {{ oncallDuty.last_name }}</td>
              <td v-for="(day, dayIndex) in dayNames" :key="dayIndex">
                <div
                  class="mb-1 px-3 py-1 rounded text-xs text-center"
                  :class="{
                    'bg-green-400 cursor-pointer':
                      !oncallDuty.duties[dayIndex].is_oncall,
                    'bg-yellow-400 cursor-pointer':
                      oncallDuty.duties[dayIndex].is_oncall,
                  }"
                  @click="
                    onClickOncallDutyCell(
                      oncallDuty.user_id,
                      oncallDuty.duties[dayIndex], // eslint-disable-line
                    )
                  "
                >
                  <br />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <base-dialog
      v-if="dialogs.dutyCancel.visible"
      title="Pamainos ieškojimas"
      :overlay-closes="true"
      @close="dialogs.dutyCancel.visible = false"
    >
      <base-label-input
        v-model="reason"
        label="Priežastis, kuri bus matoma ataskaitose dėl atšaukimo iki 3d."
        required
        placeholder="Įrašykite priežastį..."
        class="w-full mt-4"
      />

      <template v-slot:buttons>
        <div class="w-40 relative cursor-pointer ml-4">
          <base-btn class="p-3" @click="onSubmitReason">
            Atšaukti laiką
          </base-btn>
        </div>
      </template>
    </base-dialog>

    <base-dialog
      v-if="dialogs.dutyTake.visible"
      :title="dialogs.dutyTake.dateTime"
      :overlay-closes="true"
      @close="dialogs.dutyTake.visible = false"
    >
      <div v-if="currentUser.programs.length > 1" class="mb-4">
        <div class="mb-2 font-medium">
          Programa
          <span class="opacity-50">*</span>
        </div>
        <div class="flex flex-col lg:flex-row">
          <div v-if="currentUser.programs.includes('nv')" class="mr-4">
            <base-label-check
              v-model="nv_program"
              type="text"
              label="NV programa"
            />
          </div>
          <div v-if="currentUser.programs.includes('kc')" class="mr-4">
            <base-label-check
              v-model="kc_program"
              type="text"
              label="KC programa"
            />
          </div>
          <div v-if="currentUser.programs.includes('grupese')" class="mr-4">
            <base-label-check
              v-model="grupese_program"
              type="text"
              label="Grupių programa"
            />
          </div>
        </div>
      </div>
      <base-label-input
        v-model="reason"
        label="Komentaras (nebūtina)"
        placeholder="Komentaras..."
        class="w-full mt-4"
      />

      <template v-slot:buttons>
        <div class="w-40 relative cursor-pointer ml-4">
          <base-btn class="p-3" @click="onSubmitTake">
            Rezervuoti laiką
          </base-btn>
        </div>
      </template>
    </base-dialog>

    <base-dialog
      v-if="dialogs.dutyDelete.visible"
      title="Budėjimo pašalinimas"
      :overlay-closes="true"
      @close="dialogs.dutyDelete.visible = false"
    >
      <base-label-text label="Ar tikrai norite pašalinti laiką?" />
      <template v-slot:buttons>
        <div class="w-40 relative cursor-pointer ml-4">
          <base-btn class="p-3" @click="onSubmitDelete">
            Pašalinti laiką
          </base-btn>
        </div>
      </template>
    </base-dialog>

    <base-dialog
      v-if="dialogs.dutyReplace.visible"
      title="Laiko perėmimas"
      :overlay-closes="true"
      @close="dialogs.dutyReplace.visible = false"
    >
      <base-label-text label="Ar tikrai norite pasiimti kito laiką?" />
      <template v-slot:buttons>
        <div class="w-40 relative cursor-pointer ml-4">
          <base-btn class="p-3" @click="onSubmitReplace">
            Pasiimti laiką
          </base-btn>
        </div>
      </template>
    </base-dialog>

    <base-dialog
      v-if="dialogs.dutyInfo.visible"
      title="Budėjimo informacija"
      :overlay-closes="true"
      @close="dialogs.dutyInfo.visible = false"
    >
      <base-label-text
        :label="`${dialogs.dutyInfo.dutyCell.first_name} ${dialogs.dutyInfo.dutyCell.last_name} (${dialogs.dutyInfo.dutyCell.phone})`"
        class="mb-4"
      />
      <base-label-text
        v-if="dialogs.dutyInfo.dutyCell.kid"
        label="(negalima pašalinti, kol Grafike yra budėjimų)"
        class="mb-4 italic"
      />
      <base-label-text
        v-if="dialogs.dutyInfo.dutyCell.notes"
        :label="`Komentaras: ${dialogs.dutyInfo.dutyCell.notes}`"
      />
      <base-label-text
        v-if="dialogs.dutyInfo.dutyCell.programs"
        :label="`Programos: ${dialogs.dutyInfo.dutyCell.programs
          .map((p) => p.toUpperCase())
          .join(', ')}`"
      />
      <template
        v-if="
          (currentUser.role !== 'volunteer' ||
            dialogs.dutyInfo.dutyCell.user_id === currentUser.id) &&
          !dialogs.dutyInfo.dutyCell.kid
        "
        v-slot:buttons
      >
        <div class="w-48 relative cursor-pointer ml-4">
          <base-btn class="p-3" @click="onClickCancelOrDelete">
            Pašalinti budėjimą
          </base-btn>
        </div>
      </template>
    </base-dialog>
  </Layout>
</template>
